module.exports = __webpack_public_path__ + "static/media/olsenmark-logo.0a4e786f.png";